var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Card, CardExpandableContent, CardHeader, CardTitle, Divider, Flex, FlexItem, Title, } from '@patternfly/react-core';
import { createUseStyles } from 'react-jss';
import clsx from 'clsx';
export const MultiContentCardBorderVariant = {
    primary: 'primary',
    danger: 'danger',
    success: 'success',
    info: 'info',
    warning: 'warning',
    hidden: 'hidden'
};
export const MultiContentCardDividerVariant = {
    left: 'left',
    right: 'right'
};
const useStyles = createUseStyles({
    multiContentCardHeadingBorder: {
        borderBottom: 'var(--pf-v5-global--BorderWidth--sm) solid var(--pf-v5-global--disabled-color--200)',
    },
    multiContentCardLeftBorder: (leftBorderVariant) => ({
        borderLeft: `var(--pf-v5-global--BorderWidth--lg) solid var(--pf-v5-global--${leftBorderVariant}-color--100)`
    })
});
export const isCardWithProps = (card) => !!card && !React.isValidElement(card);
const MultiContentCard = (_a) => {
    var { cards = [], isToggleRightAligned = false, actions, toggleText, toggleContent, withDividers = false, leftBorderVariant = MultiContentCardBorderVariant.hidden, isExpandable = false, defaultExpanded = true, withHeaderBorder = false } = _a, rest = __rest(_a, ["cards", "isToggleRightAligned", "actions", "toggleText", "toggleContent", "withDividers", "leftBorderVariant", "isExpandable", "defaultExpanded", "withHeaderBorder"]);
    const classes = useStyles(leftBorderVariant);
    const [isExpanded, setIsExpanded] = React.useState(defaultExpanded);
    const onExpand = () => {
        setIsExpanded(!isExpanded);
    };
    const renderCards = (cards, withDividers) => (React.createElement(Flex, { alignSelf: { default: 'alignSelfStretch' }, alignItems: { default: 'alignItemsStretch' } }, cards.map((card, index) => (React.createElement(React.Fragment, null,
        index > 0 && isCardWithProps(card) && card.dividerVariant === MultiContentCardDividerVariant.left && (React.createElement(Divider, { orientation: { md: 'vertical' }, inset: { default: 'inset3xl' } })),
        React.createElement(FlexItem, { key: `card-${index}`, flex: { default: 'flex_1' } }, isCardWithProps(card) ? card.content : card),
        (index + 1 < cards.length && (withDividers || isCardWithProps(card) && card.dividerVariant === MultiContentCardDividerVariant.right)) && (React.createElement(Divider, { orientation: { md: 'vertical' }, inset: { default: 'inset3xl' } })))))));
    return (React.createElement(Card, Object.assign({ className: clsx([{ [classes.multiContentCardLeftBorder]: leftBorderVariant !== MultiContentCardBorderVariant.hidden }]), isExpanded: isExpanded }, rest),
        isExpandable && (React.createElement(CardHeader, { className: clsx({ [classes.multiContentCardHeadingBorder]: withHeaderBorder }), onExpand: onExpand, isToggleRightAligned: isToggleRightAligned, toggleButtonProps: {
                'aria-label': 'Details',
                'aria-expanded': isExpanded
            }, actions: { actions } },
            React.createElement(CardTitle, null, toggleText ? React.createElement(Title, { headingLevel: "h2", size: "xl" }, toggleText) : toggleContent))),
        isExpandable ? React.createElement(CardExpandableContent, null, renderCards(cards, withDividers)) : renderCards(cards, withDividers)));
};
export default MultiContentCard;
